import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthGuard from '../contexts/AuthGuard';
import CaptainLayout from '../layouts/CaptainLayout';

const Dashboard = lazy(() => import('../pages/modules/cashier/dashboard/Dashboard'));
const Orders = lazy(() => import('../pages/modules/cashier/operations/Orders'));

const RouteFallback = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
  </div>
);

const CaptainRoutes = () => {
  const { logout } = useAuth();

  return (
    <AuthGuard>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route element={<CaptainLayout onLogout={logout} />}>
            <Route path="/" element={<Navigate to="/captain/dashboard" replace />} />
            <Route path="/captain" element={<Navigate to="/captain/dashboard" replace />} />
            <Route path="/captain/dashboard" element={<Dashboard />} />
            <Route path="/captain/operations/orders" element={<Orders />} />
            <Route path="*" element={<Navigate to="/captain/dashboard" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </AuthGuard>
  );
};

export default CaptainRoutes;
